<template>
  <div class="share">
    <div class="img-area">
      <img src="../../assets/logo.png">
    </div>
    <div class="btn-area">
      <div @click="goto(2)" class="btn">
        <img src="../../assets/apple.png">
        <span>IOS</span>
      </div>
      <div @click="goto(1)" class="btn">
        <img src="../../assets/android.png">
        <span>Android</span>
      </div>
    </div>
    <van-popup v-model="showGuide" @click="closePop">
      <div class="guide">
        <img src="../../assets/download_guide.png" class="guide-img">
      </div>
    </van-popup>
  </div>
</template>

<script>
import { isWeixin } from '../../utils/index.js'
import { formWhere } from '../../utils/getApp'
export default {
  name: 'download',
  data() { 
    return {
      showGuide:false
    }
  },
  methods: {
    goto(type) {
      if (isWeixin()) {
        this.showGuide = true
      } else { 
        if (type == 1) {
          window.location.href = 'market://details?id=com.tailg.run.intelligence'
        } else {
          window.location.href = 'https://itunes.apple.com/us/app/id1597230423?l=zh&ls=1&mt=8'
        }
      }
    },
    closePop() { 
      this.showGuide = false
    }
  },
  mounted() { 
    if (!isWeixin()) {
      if (formWhere() == 'ios') {
        window.location.href = 'https://itunes.apple.com/us/app/id1597230423?l=zh&ls=1&mt=8'
      } else if (formWhere() == 'android') {
        window.location.href = 'market://details?id=com.tailg.run.intelligence'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .img-area{
    display: flex;
    justify-content: center;
    margin-top:100px;
    img{
      width:100px;
      height: 100px;
      border-radius: 8px;
    }
  }
  .btn-area{
    margin-top:100px;
    display: flex;
    flex-direction: column;
    align-items: center;
    img{
      width:26px;
      margin-right:20px;
    }
    .btn{
      width:200px;
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      background:#f74a43;
      color:#fff;
      margin-top:20px;
      font-size:20px;
      font-weight: bold;
      border-radius: 8px;
    }
  }
  .guide{
    position: relative;
    width:100%;
    height:100vh;
  }
  .guide-img{
      width:242px;
      // top:0;
      right:6%;
      position: absolute;
  }
  .van-popup{
    background-color:transparent;
    width:100%;
  }
</style>